var map = {
	"./feature_buy_cn.png": "37bc",
	"./feature_buy_en.png": "dcfb",
	"./feature_buy_id.png": "8812",
	"./feature_buy_ko.png": "3c16",
	"./feature_buy_th.png": "7488",
	"./feature_buy_zh.png": "2f42"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "140a";